var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDownLtr = function SvgChevronDownLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.932 34.533a3.286 3.286 0 0 1-.004-4.582 3.13 3.13 0 0 1 4.432-.063l.06.06L50.047 63.18 82.58 30.014a3.13 3.13 0 0 1 4.432-.058l.06.06a3.287 3.287 0 0 1 .056 4.52l-.058.061-34.775 35.455a3.13 3.13 0 0 1-4.43.06l-.06-.06z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDownLtr;